module.exports = __webpack_public_path__ + "static/media/Chloroform_Amnesia_Effect.9ae69e3e.mp3";